import { Component, OnInit } from "@angular/core";
import { KpiService } from "../kpi/kpi.service";

@Component({
  selector: "student-profile",
  templateUrl: "./student-profile.component.html",
  styleUrls: ["./student-profile.component.scss"],
})
export class StudentProfileComponent implements OnInit {
  studentProfile;
  errorMessage;
  student;
  school;
  role: string;
  tier: string;
  custId: number;

  constructor(private kpiservice: KpiService) {
    this.kpiservice.errorMessage = null;
    this.kpiservice.title = "Student Profile";
  }

  ngOnInit() {
    // Clear error messages
    this.kpiservice.errorMessage = null;

    this.kpiservice.getUserInfo().subscribe(
      (data) => {
        this.custId = data.organizationId;
        this.role = data.role;
        this.tier = data.sz_tier;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getStudentProfile(studentId, systemSchoolId) {
    this.kpiservice.getStudentProfileBySystemSchoolId(systemSchoolId).subscribe(
      (data) => {
        this.studentProfile = data;
        this.studentProfile.entityId = studentId;
        this.hideMessages();
      },
      (error) => {
        this.studentProfile = null;
        this.showErrorMessage("Error: " + error);
      }
    );
  }

  changeStudentData(data) {
    this.student = data;
    if (this.student.studentKEY) {
      this.getStudentProfile(
        this.student.studentKEY,
        this.student.systemSchoolId
      );
    } else {
      this.studentProfile = null;
    }
  }

  updateSchool(school) {
    this.school = school;
  }

  hideMessages() {
    this.errorMessage = null;
  }

  showErrorMessage(message) {
    this.errorMessage = message;
  }
}
